// A temporary buffer to store the text x and y position data for the currently selected text layer
export default ({
  x: 0,
  y: 0
});